export const splitFilename = (filename: string) => {
  const lastDot = filename.lastIndexOf('.')

  if (lastDot === -1 || lastDot === 0) {
    return [filename, '']
  }

  return [filename.slice(0, lastDot), filename.slice(lastDot)]
}
